import Vue from "vue";
import Component from "vue-class-component";
import ClientsDebtContainer from '@/components/ClientsDebtContainer/ClientsDebtContainer'
@Component({
    components: {
        ClientsDebtContainer,
      }
})
export default class ClientsDebt extends Vue {
    
    mounted() { }
}